export const GET_TRACKINGS = "GET_TRACKINGS"
export const GET_TRACKINGS_SUCCESS = "GET_TRACKINGS_SUCCESS"
export const GET_TRACKINGS_ERROR = "GET_TRACKINGS_ERROR"

export const GET_TRACKING = "GET_TRACKING"
export const GET_TRACKING_SUCCESS = "GET_TRACKING_SUCCESS"
export const GET_TRACKING_ERROR = "GET_TRACKING_ERROR"

export const ADD_TRACKING = "ADD_TRACKING"
export const ADD_TRACKING_SUCCESS = "ADD_TRACKING_SUCCESS"
export const ADD_TRACKING_ERROR = "ADD_TRACKING_ERROR"

export const EDIT_TRACKING = "EDIT_TRACKING"
export const EDIT_TRACKING_SUCCESS = "EDIT_TRACKING_SUCCESS"
export const EDIT_TRACKING_ERROR = "EDIT_TRACKING_ERROR"

export const DELETE_TRACKING = "DELETE_TRACKING"
export const DELETE_TRACKING_SUCCESS = "DELETE_TRACKING_SUCCESS"
export const DELETE_TRACKING_ERROR = "DELETE_TRACKING_ERROR"

export const SAVE_TRACKING_KEYWORD = "SAVE_TRACKING_KEYWORD"

export const SET_TRACKING_PAGE = "SET_TRACKING_PAGE"
export const SET_TRACKING_TOTAL_PAGE = "SET_TRACKING_TOTAL_PAGE"

export const RESET_TRACKING_FLAG = "RESET_TRACKING_FLAG"
export const RESET_TRACKING_DATA = "RESET_TRACKING_DATA"
